import { getAmpConfig } from 'shared/config/amp-config';

export const LICENSE_TYPES = ['Standard', 'Trial'];

export const BOOST_READING_PROGRAM_ID = 'boost_reading_program_id';
export const BOOST_LECTURA_PROGRAM_ID = 'boost_lectura_program_id';

export const getAquaEndpointUrl = () => `${getAmpConfig().amplifyAquaApi}/`;
